'use client'
import RightAdsPanel from '@/app/[lng]/components/AdsFructidor/RightAdsPanel/RightAdsPanel'
import { useGetRetailCompanyFilterQuery } from '@/app/globalRedux/api/searchSlice'
import {
  setRetailCompanyOrder,
  setRetailCompanySort,
} from '@/app/globalRedux/filter/retail/retailCompanyFilter'
import { RootState } from '@/app/globalRedux/store'
import { AdBannerScheduleType } from '@/app/types/adType'
import { CompanyResponse } from '@/app/types/companySearchType'
import SearchResultSort from '@/components/SearchResultSelect'
import { convertNaNToOne } from '@/lib/formatUtils'
import { useParams } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import RetailCompanyFilters from './RetailCompanyFilters'
import RetailCompanyResults from './RetailCompanyResults'
import RetailTabs from './RetailTabs'

const RetailCompanyPageContainer = ({
  adData,
}: {
  adData: AdBannerScheduleType[]
}) => {
  const dispatch = useDispatch()
  const { companyPageNo } = useParams<{
    lng: string
    companyPageNo: string[]
  }>()
  const retailCompanyFilter = useSelector(
    (state: RootState) => state.retailCompanyFilter
  )

  const {
    data: companyData,
    isLoading,
    isError,
  } = useGetRetailCompanyFilterQuery<{
    data: CompanyResponse
    isLoading: boolean
    isError: boolean
  }>({
    retailCompanyFilter: retailCompanyFilter,
    pageNo: convertNaNToOne(Number(companyPageNo?.[0] || 1)),
  })
  return (
    <div className="flex flex-row gap-7">
      <RetailCompanyFilters companyData={companyData} />

      <div className="pt-[12.5px]   border-solid mobile-width">
        <RetailTabs />

        <div className="  flex justify-end mb-2 mt-2">
          <SearchResultSort
            options="companySort"
            selectedOption={
              retailCompanyFilter?.retailCompanySelectedSortOption
            }
            sortByFunction={(value) => dispatch(setRetailCompanySort(value))}
            order={retailCompanyFilter?.retailCompanyFilterOrder}
            orderByFunction={(value) => {
              dispatch(setRetailCompanyOrder(value))
            }}
          />
        </div>
        <RetailCompanyResults
          companyData={companyData}
          isLoading={isLoading || isError}
          adData={adData}
        />
      </div>
      <RightAdsPanel />
    </div>
  )
}

export default RetailCompanyPageContainer
